'use client'

import { useState } from 'react'
import Link from 'next/link'
import { MessageCircle, Phone, ShoppingCart } from 'lucide-react'
import AddToCartModal from '@/components/AddToCartModal'
import { addToCart } from '@/lib/cart'
import { SITE } from '@/lib/site'
import type { CatalogProduct } from '@/data/catalog'

type ProductBuyBoxProps = {
  product: CatalogProduct
}

export default function ProductBuyBox({ product }: ProductBuyBoxProps) {
  const [added, setAdded] = useState(false)

  const handleAdd = () => {
    addToCart({
      slug: product.slug,
      name: product.name,
      href: product.href,
      image: product.image,
      price: product.price,
    })
    setAdded(true)
  }

  return (
    <>
      <div className="pp-actions">
        <button type="button" className="pp-btn pp-btn-cart" onClick={handleAdd}>
          <ShoppingCart size={17} />
          Sepete Ekle
        </button>
        <Link href="/sepet/" className="pp-btn pp-btn-goto">
          <ShoppingCart size={17} />
          Sepete Git
        </Link>
        <a
          href={SITE.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="pp-btn pp-btn-wa"
        >
          <MessageCircle size={17} />
          Whatsapp İle iletişime Geç
        </a>
        <a href={`tel:${SITE.phoneTel}`} className="pp-btn pp-btn-call">
          <Phone size={17} />
          Hemen Ara
        </a>
      </div>

      {added ? (
        <AddToCartModal product={product} onClose={() => setAdded(false)} />
      ) : null}
    </>
  )
}
